import { useEffect, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';

import styles from './SignupFormError.module.css';
import { useContextStateKey } from '../../../../hooks/useContextStateKey';
import { useSignupRouterDE } from '../../../../hooks/useSignupRouter/useSignupRouterDE';
import { getAmplitudeDefaultEventProperties } from '../../../../utils/amplitudeEvents';
import { Button } from '../../../Button/Button';

const SignupFormErrorDE = () => {
  const [isLoading, setIsLoading] = useState(false);

  const stateKey = useContextStateKey();

  const { navigateSignupDE } = useSignupRouterDE();

  useEffect(() => {
    tracking.ampli.lendingDecisionErrored({
      'Error type': _.capitalize(_.startCase('default')),
      ...getAmplitudeDefaultEventProperties(),
    });
  }, []);

  const handleClick = async () => {
    setIsLoading(true);
    await navigateSignupDE('schritt-2', stateKey);
    setIsLoading(false);
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>
        Leider konnten wir keine Entscheidung treffen.
      </h1>
      <div className={styles.content}>
        {' '}
        <p className={styles.content}>
          Leider konnten wir die Prüfung aufgrund eines technischen Fehlers
          nicht abschließen. Unser Team untersucht das Problem und wir werden
          Sie kontaktieren, sobald wir es behoben haben.
          <a
            href="mailto:support@iwoca.de"
            data-testid="email-link"
            target="_blank"
            rel="noreferrer"
          >
            E-Mail
          </a>{' '}
          oder{' '}
          <a
            href="tel:06994323020"
            data-testid="call-link"
            target="_blank"
            rel="noreferrer"
          >
            rufen Sie uns an.
          </a>
        </p>
      </div>
      <Button loading={isLoading} onClick={handleClick}>
        Zurück
      </Button>
    </div>
  );
};

export default SignupFormErrorDE;
